import { useMountEffect } from '@react-hookz/web';

import { useAppDispatch } from '../app/hooks';
import { asyncLogInWithExistingSession } from '../features/auth/slice';

export function useCognitoLogin() {
    const dispatch = useAppDispatch();

    useMountEffect(() => {
        dispatch(asyncLogInWithExistingSession());
    });
}
